import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CurafidaAuthService } from '../authentication/curafida-auth.service';
import { Logger, LoggingService, LogLevel } from '../logging/logging.service';
import { ConfigService } from '../config/services/config.service';
import { UserRoles } from '../user/entities/user-roles';

@Injectable({
    providedIn: 'root',
})
export class RootGuardService {
    protected readonly log: Logger;

    constructor(
        private readonly authService: CurafidaAuthService,
        private readonly router: Router,
        private readonly configService: ConfigService,
        private readonly loggingService: LoggingService,
    ) {
        this.log = this.loggingService.getLogger(this.constructor.name);
        this.log.setLevel(LogLevel.DEBUG);
    }

    canActivate(): boolean | UrlTree {
        const roles = this.authService.loggedInUser()?.roles ?? [];
        if (roles.length > 0) {
            const rootLocal = this.configService.frontendConfig().rootUrls;
            if (!rootLocal) {
                this.log.warn('[canActivate] No rootUrls configured. Navigate to /login');
                return this.router.parseUrl('/login');
            }
            const root = rootLocal.find((page) => roles.includes(page.role as UserRoles));
            if (root?.url) {
                this.log.debug(`[canActivate] Navigate to user root URL based role (${root.role}): ${root.url}`);
                return this.router.parseUrl(root.url);
            }
            if (!root) {
                this.log.warn(
                    `[canActivate] No root URL specified for user role. Navigate to the App default URL ${this.configService.frontendConfig().defaultUrl}`,
                );
                return this.router.parseUrl(this.configService.frontendConfig().defaultUrl);
            }
        }
        this.log.info(`[canActivate] Default action: navigate to /login`);
        return this.router.parseUrl('/login');
    }
}
